/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: string;
};

export type AddParticipantsDto = {
  __typename?: 'AddParticipantsDto';
  participants: Array<ParticipantDto>;
};

export type AddParticipantsInput = {
  participants: Array<RegisterInput>;
};

export type CreateSeminarInput = {
  accreditation?: InputMaybe<Scalars['String']>;
  capacity?: InputMaybe<Scalars['Float']>;
  city: Scalars['String'];
  date: Scalars['DateTime'];
  deposit?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  identifier: Scalars['String'];
  lector?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  practiceDuration?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['String']>;
  substituteCapacity?: InputMaybe<Scalars['Float']>;
  theoryDuration?: InputMaybe<Scalars['String']>;
  type?: SeminarType;
};

export type CreateUserInput = {
  /** Auth0 user id */
  userId: Scalars['String'];
};

export type DeleteParticipantDto = {
  __typename?: 'DeleteParticipantDto';
  id: Scalars['ID'];
};

export type DeleteParticipantsDto = {
  __typename?: 'DeleteParticipantsDto';
  deletedParticipants: Array<DeleteParticipantDto>;
};

export type DeleteParticipantsInput = {
  participantIds: Array<Scalars['ID']>;
};

export type DeleteSeminarDto = {
  __typename?: 'DeleteSeminarDto';
  id: Scalars['Int'];
};

export type DeleteSeminarInput = {
  id: Scalars['Int'];
};

export type GeneratePresignedUrlInput = {
  contentType: Scalars['String'];
  filename: Scalars['String'];
};

export type GeneratePresignedUrlsInput = {
  files: Array<GeneratePresignedUrlInput>;
};

export type GetSeminarsInput = {
  fromDate?: InputMaybe<Scalars['DateTime']>;
  seminarId?: InputMaybe<Scalars['Int']>;
};

export type IdentityDto = {
  __typename?: 'IdentityDto';
  address: Scalars['String'];
  degree: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addParticipants: AddParticipantsDto;
  createSeminar: SeminarDto;
  createUser: UserDto;
  deleteParticipants: DeleteParticipantsDto;
  deleteSeminar: DeleteSeminarDto;
  generatePresignedUrls: Array<PresignedUrlDto>;
  register: ParticipantDto;
  updateParticipant: ParticipantDto;
  updateSeminar: SeminarDto;
  updateUserIdentity: IdentityDto;
};


export type MutationAddParticipantsArgs = {
  addParticipantsInput: AddParticipantsInput;
};


export type MutationCreateSeminarArgs = {
  createSeminarInput: CreateSeminarInput;
};


export type MutationCreateUserArgs = {
  createUserInput: CreateUserInput;
};


export type MutationDeleteParticipantsArgs = {
  deleteParticipantsInput: DeleteParticipantsInput;
};


export type MutationDeleteSeminarArgs = {
  deleteSeminarInput: DeleteSeminarInput;
};


export type MutationGeneratePresignedUrlsArgs = {
  generatePresignedUrlsInput: GeneratePresignedUrlsInput;
};


export type MutationRegisterArgs = {
  registerInput: RegisterInput;
};


export type MutationUpdateParticipantArgs = {
  updateParticipantInput: UpdateParticipantInput;
};


export type MutationUpdateSeminarArgs = {
  updateSeminarInput: UpdateSeminarInput;
};


export type MutationUpdateUserIdentityArgs = {
  identity: UpdateIdentityInput;
};

export type ParticipantDto = {
  __typename?: 'ParticipantDto';
  address?: Maybe<Scalars['String']>;
  branchOffice?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  dateOfBirth: Scalars['DateTime'];
  education?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fileUrls?: Maybe<Array<Scalars['String']>>;
  ico?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  invoiceEmail?: Maybe<Scalars['String']>;
  isSubstitute?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<PaymentMethod>;
  phone?: Maybe<Scalars['String']>;
  placeOfBirth?: Maybe<Scalars['String']>;
  school?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  wantsAllowance?: Maybe<Scalars['Boolean']>;
};

/** Possible payment methods for seminar. */
export enum PaymentMethod {
  Cash = 'CASH',
  Free = 'FREE',
  Invoice = 'INVOICE'
}

export type PresignedUrlDto = {
  __typename?: 'PresignedUrlDto';
  fileKey: Scalars['String'];
  publicUrl: Scalars['String'];
  uploadUrl: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  identity: IdentityDto;
  seminars: Array<SeminarDto>;
};


export type QuerySeminarsArgs = {
  seminarsInput: GetSeminarsInput;
};

export type RegisterInput = {
  address?: InputMaybe<Scalars['String']>;
  branchOffice?: InputMaybe<Scalars['String']>;
  dateOfBirth: Scalars['DateTime'];
  education?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  fileUrls?: InputMaybe<Array<Scalars['String']>>;
  ico?: InputMaybe<Scalars['String']>;
  invoiceEmail?: InputMaybe<Scalars['String']>;
  isSubstitute?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  phone?: InputMaybe<Scalars['String']>;
  placeOfBirth?: InputMaybe<Scalars['String']>;
  school?: InputMaybe<Scalars['String']>;
  seminarId: Scalars['Int'];
  wantsAllowance?: InputMaybe<Scalars['Boolean']>;
};

export type SeminarDto = {
  __typename?: 'SeminarDto';
  accreditation?: Maybe<Scalars['String']>;
  author?: Maybe<IdentityDto>;
  authorId?: Maybe<Scalars['String']>;
  capacity?: Maybe<Scalars['Int']>;
  city: Scalars['String'];
  date: Scalars['DateTime'];
  deposit?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  identifier: Scalars['String'];
  lector?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  participants?: Maybe<Array<ParticipantDto>>;
  practiceDuration?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  registeredParticipants?: Maybe<Scalars['Int']>;
  substituteCapacity?: Maybe<Scalars['Int']>;
  theoryDuration?: Maybe<Scalars['String']>;
  type: SeminarType;
};

/** Seminar type - either default or IDZ. */
export enum SeminarType {
  Default = 'DEFAULT',
  Digcompedu = 'DIGCOMPEDU',
  Idz = 'IDZ',
  Studium = 'STUDIUM'
}

export type UpdateIdentityInput = {
  address: Scalars['String'];
  degree: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
};

export type UpdateParticipantInput = {
  address?: InputMaybe<Scalars['String']>;
  branchOffice?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']>;
  education?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  fileUrls?: InputMaybe<Array<Scalars['String']>>;
  ico?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  invoiceEmail?: InputMaybe<Scalars['String']>;
  isSubstitute?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  phone?: InputMaybe<Scalars['String']>;
  placeOfBirth?: InputMaybe<Scalars['String']>;
  school?: InputMaybe<Scalars['String']>;
  wantsAllowance?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateSeminarInput = {
  accreditation?: InputMaybe<Scalars['String']>;
  capacity?: InputMaybe<Scalars['Float']>;
  city?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['DateTime']>;
  deposit?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  identifier?: InputMaybe<Scalars['String']>;
  lector?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  practiceDuration?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['String']>;
  substituteCapacity?: InputMaybe<Scalars['Float']>;
  theoryDuration?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<SeminarType>;
};

export type UserDto = {
  __typename?: 'UserDto';
  seminars: Array<SeminarDto>;
  userId: Scalars['String'];
};

export type AddParticipantsMutationMutationVariables = Exact<{
  addParticipantsInput: AddParticipantsInput;
}>;


export type AddParticipantsMutationMutation = { __typename?: 'Mutation', addParticipants: { __typename?: 'AddParticipantsDto', participants: Array<{ __typename?: 'ParticipantDto', name: string }> } };

export type CreateSeminarMutationVariables = Exact<{
  seminarInput: CreateSeminarInput;
}>;


export type CreateSeminarMutation = { __typename?: 'Mutation', createSeminar: { __typename?: 'SeminarDto', id: number, identifier: string, lector?: string | null, date: string, name: string, accreditation?: string | null } };

export type DeleteParticipantsMutationVariables = Exact<{
  participants: DeleteParticipantsInput;
}>;


export type DeleteParticipantsMutation = { __typename?: 'Mutation', deleteParticipants: { __typename?: 'DeleteParticipantsDto', deletedParticipants: Array<{ __typename?: 'DeleteParticipantDto', id: string }> } };

export type DeleteSeminarMutationVariables = Exact<{
  seminar: DeleteSeminarInput;
}>;


export type DeleteSeminarMutation = { __typename?: 'Mutation', deleteSeminar: { __typename?: 'DeleteSeminarDto', id: number } };

export type GeneratePresignedUrlsMutationVariables = Exact<{
  generatePresignedUrlsInput: GeneratePresignedUrlsInput;
}>;


export type GeneratePresignedUrlsMutation = { __typename?: 'Mutation', generatePresignedUrls: Array<{ __typename?: 'PresignedUrlDto', uploadUrl: string, fileKey: string, publicUrl: string }> };

export type GetSeminarQueryVariables = Exact<{
  seminarInput: GetSeminarsInput;
}>;


export type GetSeminarQuery = { __typename?: 'Query', seminars: Array<{ __typename?: 'SeminarDto', id: number, identifier: string, name: string, date: string, endDate?: string | null, lector?: string | null, accreditation?: string | null, city: string, duration?: string | null, price?: string | null, deposit?: string | null, theoryDuration?: string | null, practiceDuration?: string | null, capacity?: number | null, substituteCapacity?: number | null, type: SeminarType, participants?: Array<{ __typename?: 'ParticipantDto', id: number, name: string, dateOfBirth: string, paymentMethod?: PaymentMethod | null, email?: string | null, phone?: string | null, school?: string | null, ico?: string | null, invoiceEmail?: string | null, note?: string | null, address?: string | null, placeOfBirth?: string | null, createdAt: string, updatedAt: string, wantsAllowance?: boolean | null, fileUrls?: Array<string> | null, education?: string | null, branchOffice?: string | null, isSubstitute?: boolean | null }> | null, author?: { __typename?: 'IdentityDto', firstName: string, lastName: string, degree: string, email: string, address: string, phone: string } | null }> };

export type GetSeminarsQueryVariables = Exact<{
  seminarsInput: GetSeminarsInput;
}>;


export type GetSeminarsQuery = { __typename?: 'Query', seminars: Array<{ __typename?: 'SeminarDto', id: number, identifier: string, name: string, date: string, endDate?: string | null, lector?: string | null, accreditation?: string | null, city: string, duration?: string | null, price?: string | null, type: SeminarType, capacity?: number | null, deposit?: string | null, theoryDuration?: string | null, practiceDuration?: string | null, substituteCapacity?: number | null, participants?: Array<{ __typename?: 'ParticipantDto', id: number }> | null }> };

export type GetUserIdentityQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserIdentityQuery = { __typename?: 'Query', identity: { __typename?: 'IdentityDto', email: string, address: string, firstName: string, lastName: string, degree: string, phone: string } };

export type UpdateParticipantMutationVariables = Exact<{
  participantInput: UpdateParticipantInput;
}>;


export type UpdateParticipantMutation = { __typename?: 'Mutation', updateParticipant: { __typename?: 'ParticipantDto', id: number } };

export type UpdateSeminarMutationVariables = Exact<{
  seminarInput: UpdateSeminarInput;
}>;


export type UpdateSeminarMutation = { __typename?: 'Mutation', updateSeminar: { __typename?: 'SeminarDto', id: number, lector?: string | null, name: string, date: string, accreditation?: string | null } };

export type UpdateUserIdentityMutationVariables = Exact<{
  userIdentity: UpdateIdentityInput;
}>;


export type UpdateUserIdentityMutation = { __typename?: 'Mutation', updateUserIdentity: { __typename?: 'IdentityDto', firstName: string, lastName: string, degree: string, phone: string, address: string, email: string } };


export const AddParticipantsMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddParticipantsMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addParticipantsInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddParticipantsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addParticipants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"addParticipantsInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addParticipantsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<AddParticipantsMutationMutation, AddParticipantsMutationMutationVariables>;
export const CreateSeminarDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSeminar"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seminarInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSeminarInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSeminar"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createSeminarInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seminarInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"lector"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"accreditation"}}]}}]}}]} as unknown as DocumentNode<CreateSeminarMutation, CreateSeminarMutationVariables>;
export const DeleteParticipantsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteParticipants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participants"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteParticipantsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteParticipants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"deleteParticipantsInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participants"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletedParticipants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteParticipantsMutation, DeleteParticipantsMutationVariables>;
export const DeleteSeminarDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteSeminar"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seminar"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteSeminarInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteSeminar"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"deleteSeminarInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seminar"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteSeminarMutation, DeleteSeminarMutationVariables>;
export const GeneratePresignedUrlsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"generatePresignedUrls"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"generatePresignedUrlsInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GeneratePresignedUrlsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generatePresignedUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"generatePresignedUrlsInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"generatePresignedUrlsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fileKey"}},{"kind":"Field","name":{"kind":"Name","value":"publicUrl"}}]}}]}}]} as unknown as DocumentNode<GeneratePresignedUrlsMutation, GeneratePresignedUrlsMutationVariables>;
export const GetSeminarDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSeminar"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seminarInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetSeminarsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seminars"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"seminarsInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seminarInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"lector"}},{"kind":"Field","name":{"kind":"Name","value":"accreditation"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"deposit"}},{"kind":"Field","name":{"kind":"Name","value":"theoryDuration"}},{"kind":"Field","name":{"kind":"Name","value":"practiceDuration"}},{"kind":"Field","name":{"kind":"Name","value":"capacity"}},{"kind":"Field","name":{"kind":"Name","value":"substituteCapacity"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"school"}},{"kind":"Field","name":{"kind":"Name","value":"ico"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceEmail"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"placeOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"wantsAllowance"}},{"kind":"Field","name":{"kind":"Name","value":"fileUrls"}},{"kind":"Field","name":{"kind":"Name","value":"education"}},{"kind":"Field","name":{"kind":"Name","value":"branchOffice"}},{"kind":"Field","name":{"kind":"Name","value":"isSubstitute"}}]}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"degree"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}}]}}]} as unknown as DocumentNode<GetSeminarQuery, GetSeminarQueryVariables>;
export const GetSeminarsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSeminars"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seminarsInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetSeminarsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seminars"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"seminarsInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seminarsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"lector"}},{"kind":"Field","name":{"kind":"Name","value":"accreditation"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"capacity"}},{"kind":"Field","name":{"kind":"Name","value":"deposit"}},{"kind":"Field","name":{"kind":"Name","value":"theoryDuration"}},{"kind":"Field","name":{"kind":"Name","value":"practiceDuration"}},{"kind":"Field","name":{"kind":"Name","value":"substituteCapacity"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetSeminarsQuery, GetSeminarsQueryVariables>;
export const GetUserIdentityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserIdentity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"degree"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}}]} as unknown as DocumentNode<GetUserIdentityQuery, GetUserIdentityQueryVariables>;
export const UpdateParticipantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateParticipant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participantInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateParticipantInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateParticipant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateParticipantInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participantInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateParticipantMutation, UpdateParticipantMutationVariables>;
export const UpdateSeminarDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSeminar"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seminarInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSeminarInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSeminar"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateSeminarInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seminarInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lector"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"accreditation"}}]}}]}}]} as unknown as DocumentNode<UpdateSeminarMutation, UpdateSeminarMutationVariables>;
export const UpdateUserIdentityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserIdentity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIdentity"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateIdentityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserIdentity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"identity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIdentity"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"degree"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<UpdateUserIdentityMutation, UpdateUserIdentityMutationVariables>;